import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: File };

const initialState: State = { state: 'idle' };

@Injectable()
export class BoardResolutionFileStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<File>((_, data) => ({ state: 'valid', data }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));

  constructor() {
    super(initialState);
  }
}
